import { request } from '@langlois/request';

export async function getInvitations ({ commit }, clubId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}/team/invitation`);

		const response = await request.get(url);

		if (!response.ok || response.status === 204) return;

		const invitations = await response.json();

		commit(`setInvitations`, invitations);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the club's active invitations.`,
			type: `warning`
		}, { root: true });
	}
}
